import { Box } from "@mui/material";
import Input from "components/common/Input";
import * as React from "react";
import { tokens } from "styles/Tokens";

interface ItemType {
  id: number;
  Title: string;
  Description: string;
}

interface Props {
  setSectionTitleValue: (state: string, callback?: () => void) => void;
  setSectionDescriptionValue: (state: string, callback?: () => void) => void;
  item: ItemType;
  register: any;
  errors: any;
}

function SectionFormContent(props: Props, ref: any) {
  const { setSectionTitleValue, setSectionDescriptionValue, item, register, errors } = props;

  return (
    <>
      <form>
        <Box width="100%" textAlign={"start"} display={"flex"} alignItems="flex-start" flexWrap="wrap" gap={"10px"}>
          <Input
            handleChangeUpdate={(val) => {
              setSectionTitleValue(val);
            }}
            name="Title"
            register={register}
            error={errors?.Title}
            validations={{ required: true }}
            label="Title"
            placeholder="Add a brief title"
            textVariant="body2"
            color={tokens.Text.General.PrimaryHeadline}
            value={item?.Title}
          />
          <Input
            handleChangeUpdate={(val) => {
              setSectionDescriptionValue(val);
            }}
            label="Description"
            isMultiline={true}
            rowsCount={2}
            placeholder="Write a short summary"
            textVariant="body2"
            color={tokens.Text.General.PrimaryHeadline}
            value={item?.Description}
          />
        </Box>
      </form>
    </>
  );
}

export default React.forwardRef(SectionFormContent);
